"use client";
import React, { useEffect, useRef, useState } from "react";
import { Astro_Strings } from "../Strings";
import styles from "./TodayPanchang.module.scss";
import Image from "next/image";
import { Images } from "@/utils/imageRelativePaths";
import PageHeaderCard from "../components/PageHeaderCard";
import MiniCard from "../components/MiniCard";
import WhiteCard from "../components/WhiteCard";
import ListCard from "../components/ListCard";
import {
  ADDITIONAL_DETAILS_DATA,
  ASTROLOGERS_DATA,
  AUSPICIOUS_TIMINGS_DETAILS,
  INAUSPICIOUS_TIMINGS_DETAILS,
  MINI_CARD_DETAILS,
  PANCHANG_DATA,
} from "../Data";
import AstroContainer from "../components/AstroContainer";
import useDebounce from "../../../customhooks/useDebounce";
import {
  fetchLocationData,
  fetchPanchangData,
  fetchTimeZone,
} from "@/services/astro.service";
import { AstroDailyPanchangData, GeoLocation } from "../Enum";
import useOnClickOutside from "@/customhooks/useOnClickOutside";
import Header from "@/common/components/Header";
import AstroPageHeader from "@/modules/Astro/AstroPageHeader";
import useAppContext from "@/customhooks/useAppContext";

const TodayPanchang = () => {
  const token = useAppContext()?.auth?.token ?? "";
  const [inputData, setInputData] = useState<string>("");
  const [searchOptions, setSearchOptions] = useState<GeoLocation[]>([]);
  const [selectedCity, setSelectedCity] = useState<GeoLocation>({
    place_name: "Bangalore",
    latitude: "12.97194",
    longitude: "77.59369",
    country_code: "IN",
    timezone_id: "Asia/Kolkata",
  });
  const [panchangData, setPanchangData] = useState<AstroDailyPanchangData>();
  const debouncedValue = useDebounce<string>(inputData);
  const ref = useRef(null);
  useOnClickOutside(ref, onClearInput);

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputData(event.target.value);
  };

  const getLocationData = async () => {
    const locationData = await fetchLocationData(debouncedValue?.trim(), token);
    setSearchOptions(locationData?.geonames ?? []);
  };

  const getPanchangData = async () => {
    if (selectedCity?.country_code) {
      const timezoneData = await fetchTimeZone({
        date: new Date().toString(),
        latitude: selectedCity?.latitude ?? "",
        longitude: selectedCity?.longitude ?? "",
        token,
      });
      const data = await fetchPanchangData({
        date: new Date().toString(),
        lat: selectedCity?.latitude,
        long: selectedCity?.longitude,
        tzone: timezoneData?.timezone ?? "",
        token,
      });
      setPanchangData(data);
    }
  };

  function onClearInput() {
    setInputData("");
    setSearchOptions([]);
  }

  useEffect(() => {
    getPanchangData();
  }, [selectedCity?.place_name]);

  useEffect(() => {
    if (debouncedValue?.trim()?.length > 2) {
      void getLocationData();
    } else {
      setSearchOptions([]);
    }
  }, [debouncedValue]);

  const InputSection = (
    <div className={styles.inputSection}>
      <Image src={Images.search} alt="search" height={16} width={16} />
      <input
        type="text"
        placeholder="Select Place to see the Panchang"
        value={inputData}
        onChange={handleSearchChange}
      />
      {inputData && inputData.length > 0 ? (
        <Image
          src={Images.iconCross}
          alt="close"
          height={10}
          width={10}
          onClick={onClearInput}
        />
      ) : (
        ""
      )}
      {searchOptions?.length > 0 && (
        <div className={styles.dropdown}>
          {searchOptions?.map((location, index) => (
            <div
              className={styles.dropdownItem}
              key={index}
              onClick={() => {
                if (location?.country_code) {
                  setSelectedCity(location);
                }
                onClearInput();
              }}
            >
              {location?.place_name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
  return (
    <>
      <AstroPageHeader content={InputSection} />
      <div className={styles.topWrapper}>
        <Header title={Astro_Strings.TODAYS_PANCHANG} theme="dark" />
        {InputSection}
      </div>
      <div className={styles.bottomWrapper}>
        <div className={styles.panchangWrapper}>
          <div className={styles.todayPanchagWrapper}>
            <PageHeaderCard
              title={Astro_Strings.TODAYS_PANCHANG}
              subTitle={new Date().toDateString()}
              location={selectedCity?.place_name}
            />
            <MiniCard
              data={MINI_CARD_DETAILS}
              sunDetails={panchangData?.sunDetails}
            />
            <WhiteCard data={panchangData?.panchangDetails ?? []} />
          </div>
          <ListCard
            className={styles.ausTiming}
            title={Astro_Strings.AUSPICIOUS_TIMING}
            subTitle={Astro_Strings.SHUBHA_MUHURAT}
            data={panchangData?.auspiciousTime ?? []}
          />
          <ListCard
            className={styles.inausTiming}
            title={Astro_Strings.INAUSPICIOUS_TIMING}
            subTitle={Astro_Strings.ASHUBHA_MUHURAT}
            data={panchangData?.inAuspiciousTime ?? []}
          />
        </div>
        <h2>{Astro_Strings.ADDITIONAL_DETAILS}</h2>
        <WhiteCard data={panchangData?.additionalDetails ?? []} />
        <AstroContainer />
      </div>
    </>
  );
};

export default TodayPanchang;
